import { React, useState } from 'react';
import conditionData from '../data/data_models';
import TreatmentTable from './TreatmentTable';
import QualifierToggleGroup from './QualifierToggleGroup';


export default function Condition({ cond }) {
  const [sideEffectsState, setSideEffectsState] = useState([...new Set(cond.treatments.map(t => t.side_effects).flat())].map(t => ({ name: t, checked: false })))
  const [indicationsState, setIndicationsState] = useState([...new Set(cond.treatments.map(t => t.indications).flat())].map(t => ({ name: t, checked: false })))
  const [formulationsState, setFormulationsState] = useState([...new Set(cond.treatments.map(t => t.formulations).flat())].map(t => ({ name: t, checked: true })))


  return (
    <div>
      <h2>{cond.name}</h2>

      <p>{cond.description} (Read more on {cond.links.map((link, i) => [
        i > 0 && ", ",
        <a href={link.url}>{link.text}</a>
      ])}).</p>

      {!cond.relatedIds.length ||
        <p>Do you actually want: {cond.relatedIds.map((rid, i) => [
          i > 0 && ", ",
          <a href="FIXME">{conditionData.find(c => c.id === rid).name}</a>
        ])}? If you're not sure, see a doctor!
        </p>
      }

      <QualifierToggleGroup
        qualifiers={indicationsState}
        setQualifiers={setIndicationsState}
        text="I'm experiencing:">
      </QualifierToggleGroup>

      <QualifierToggleGroup
        qualifiers={sideEffectsState}
        setQualifiers={setSideEffectsState}
        text="I'm at risk for:"
        disqualifier={true}>
      </QualifierToggleGroup>

      <QualifierToggleGroup
        qualifiers={formulationsState}
        setQualifiers={setFormulationsState}
        text="I'm comfortable taking:">
      </QualifierToggleGroup>

      <TreatmentTable
        treatments={cond.treatments}
        checkedSideEffects={sideEffectsState.filter(s => s.checked).map(s => s.name)}
        checkedIndications={indicationsState.filter(i => i.checked).map(i => i.name)}
        checkedFormulations={formulationsState.filter(f => f.checked).map(f => f.name)}>
      </TreatmentTable>
    </div >
  )
}
